/* eslint-disable */

import React from 'react'
import { Card, } from '../ui/card'

const StatCard = ({ title, amount, amountColor, description, subtext, icon: Icon, iconColor, iconTextColor }) => {
    return (
        <Card className='shadow-none p-6 space-y-2'>
            <div className='flex justify-between items-center'>
                <div>
                    <h3 className='text-lg text-black-400 font-semibold'>{title}</h3>
                    <h2 className={`text-3xl ${amountColor} font-bold`}>{amount}</h2>
                </div>

                <div className={`flex items-center justify-center rounded-full p-2 ${iconColor} w-10 h-10`}>
                    <Icon className={`w-6 h-6  ${iconTextColor} `} />
                </div>

            </div>

            <div>
                <p className='text-sm text-black-400'>{description}</p>
                <p className='text-sm text-muted-foreground'>{subtext}</p>
            </div>
        </Card>
    )
}

export default StatCard
